import { Icon } from '@eventbrite/eds-icon';
import React from 'react';
import { DropdownItem } from '../../../../types';
import styles from './SimpleDropdownItem.module.scss';

const SimpleDropdownItem = ({ path, iconType, text }: DropdownItem) => {
    return (
        <li>
            <a href={path} className={styles.simpleDropdownItem} tabIndex={0}>
                {iconType ? (
                    <span className={styles.iconContainer}>
                        <Icon type={iconType} />
                    </span>
                ) : null}
                {text}
            </a>
        </li>
    );
};

export default SimpleDropdownItem;
